import Cleaning from "./assets/images/Cleaning.jpg";
import Electrical from "./assets/images/Electrical.jpg";
import AirConditioning from "./assets/images/AirConditioning.jpg";
import Blacksmith from "./assets/images/Blacksmith.jpg";
import Joiner from "./assets/images/Joiner.jpg";
import Plumber from "./assets/images/Plumber.jpg";
import Opinions1 from "./assets/images/Opinions1.jpeg";
import Opinions2 from "./assets/images/Opinions2.jpeg";
import Opinions3 from "./assets/images/Opinions3.jpeg";

export const servicesData = [
  {
    id: 1,
    name: "سباكة",
    image: Plumber,
    icon: "🔧", // Replace with your actual icons or components
    description:
      "خدمات سباكة احترافية لحل جميع مشاكل المياه والصرف الصحي في منزلك أو مكتبك بأيدي متخصصين مهرة.",
  },
  {
    id: 2,
    image: Electrical,
    name: "كهرباء",
    icon: "⚡",
    description:
      "خدمات الكهرباء المنزلية والتجارية بأعلى معايير الأمان والجودة. نقوم بتركيب وإصلاح جميع الأنظمة الكهربائية.",
  },
  {
    id: 3,
    image: Joiner,
    name: "نجارة",
    icon: "🪚",
    description:
      "خدمات نجارة متميزة لتصنيع وإصلاح الأثاث وأعمال الخشب بتصميمات عصرية وخامات عالية الجودة.",
  },
  {
    id: 4,
    name: "حدادة",
    image: Blacksmith,
    icon: "🔨",
    description:
      "أعمال الحدادة والمعادن بجميع أنواعها. نقدم خدمات تصنيع وتركيب الأبواب والنوافذ والهياكل المعدنية.",
  },
  {
    id: 5,
    name: "تنظيف منزلي",
    image: Cleaning,
    icon: "🧹",
    description:
      "خدمات تنظيف منزلية شاملة باستخدام أفضل المنظفات والمعدات الحديثة لمنزل نظيف وصحي.",
  },
  {
    id: 6,
    image: AirConditioning,
    name: "صيانة تكييف",
    icon: "❄️",
    description:
      "خدمات صيانة وتركيب وإصلاح أنظمة التكييف والتبريد بأيدي فنيين محترفين وبأسعار تنافسية.",
  },
];

// Sample packages data
export const packages = {
  monthly: [
    {
      id: 1,
      name: "الباقة الأساسية",
      price: 99,
      period: "شهرياً",
      description: "مناسبة للمنازل الصغيرة والشقق",
      features: [
        "3 زيارات في الشهر",
        "الصيانة الأساسية",
        "دعم فني على مدار الساعة",
        "ضمان لمدة شهر",
      ],
      popular: false,
      color: "#167bbb",
    },
    {
      id: 2,
      name: "الباقة المميزة",
      price: 199,
      period: "شهرياً",
      description: "مناسبة للمنازل المتوسطة",
      features: [
        "6 زيارات في الشهر",
        "جميع خدمات الصيانة",
        "دعم فني على مدار الساعة",
        "خصم 10% على قطع الغيار",
        "ضمان لمدة 3 أشهر",
      ],
      popular: true,
      color: "#5cb85c",
    },
    {
      id: 3,
      name: "الباقة الذهبية",
      price: 349,
      period: "شهرياً",
      description: "مناسبة للمنازل الكبيرة والفلل",
      features: [
        "زيارات غير محدودة",
        "جميع خدمات الصيانة",
        "دعم فني على مدار الساعة",
        "خصم 20% على قطع الغيار",
        "أولوية الخدمة",
        "ضمان لمدة 6 أشهر",
      ],
      popular: false,
      color: "#167bbb",
    },
  ],
  yearly: [
    {
      id: 4,
      name: "الباقة الأساسية",
      price: 999,
      period: "سنوياً",
      description: "مناسبة للمنازل الصغيرة والشقق",
      features: [
        "3 زيارات شهرياً",
        "الصيانة الأساسية",
        "دعم فني على مدار الساعة",
        "ضمان طوال مدة الاشتراك",
        "خصم 10% على خدمات إضافية",
      ],
      popular: false,
      color: "#167bbb",
      saving: "وفر 189 ريال",
    },
    {
      id: 5,
      name: "الباقة المميزة",
      price: 1999,
      period: "سنوياً",
      description: "مناسبة للمنازل المتوسطة",
      features: [
        "6 زيارات شهرياً",
        "جميع خدمات الصيانة",
        "دعم فني على مدار الساعة",
        "خصم 15% على قطع الغيار",
        "ضمان طوال مدة الاشتراك",
        "خدمة الطوارئ المجانية",
      ],
      popular: true,
      color: "#5cb85c",
      saving: "وفر 389 ريال",
    },
    {
      id: 6,
      name: "الباقة الذهبية",
      price: 3499,
      period: "سنوياً",
      description: "مناسبة للمنازل الكبيرة والفلل",
      features: [
        "زيارات غير محدودة",
        "جميع خدمات الصيانة الشاملة",
        "دعم فني VIP",
        "خصم 25% على قطع الغيار",
        "أولوية قصوى للخدمة",
        "ضمان شامل",
        "فحص وقائي ربع سنوي",
      ],
      popular: false,
      color: "#167bbb",
      saving: "وفر 689 ريال",
    },
  ],
};

// Secondary packages (one-time services)
export const secondaryPackages = [
  {
    id: 101,
    name: "فحص شامل",
    price: 249,
    description: "فحص شامل لجميع أنظمة المنزل مع تقرير مفصل",
    icon: "🔍",
  },
  {
    id: 102,
    name: "صيانة تكييف",
    price: 199,
    description: "تنظيف وصيانة لوحدات التكييف مع تغيير الفلاتر",
    icon: "❄️",
  },
  {
    id: 103,
    name: "تنظيف عميق",
    price: 349,
    description: "تنظيف عميق للمنزل بالكامل شامل السجاد والكنب",
    icon: "🧹",
  },
  {
    id: 104,
    name: "خدمة طوارئ",
    price: 299,
    description: "خدمة طوارئ للسباكة والكهرباء متوفرة 24/7",
    icon: "🚨",
  },
];

export const customers = [
  {
    id: 1,
    name: "محمد إبراهيم",
    rating: 5,
    count: "منذ 10 ايام",
    review:
      "تجربتي مع خدمة حوف المنازل كانت رائعة بكل المقاييس. العمال وصلوا في الوقت المحدد تماماً وقاموا بتنظيف منزلي بشكل احترافي وسريع. خدمة العملاء كانت متعاونة للغاية وسعر الخدمة مناسب جداً مقارنة بالجودة العالية. سأستمر في التعامل معهم بالتأكيد وأنصح بهم لكل من يبحث عن خدمة تنظيف ممتازة.",
    image: Opinions1,
  },
  {
    id: 2,
    name: "مصطفى أحمد",
    rating: 5,
    count: "3/2/2025",
    review:
      "استعنت بخدمة حوف المنازل لتنظيف الشقة الجديدة قبل الانتقال إليها. النتيجة كانت مذهلة! المنزل أصبح يلمع من النظافة والعطر الجميل. فريق العمل كان محترم جداً ويتعامل مع الأثاث والمقتنيات بحرص شديد. الدقة في التفاصيل والاهتمام بكل زاوية من المنزل جعلني سعيداً جداً بالخدمة وسأكررها بالتأكيد.",
    image: Opinions2,
  },
  {
    id: 3,
    name: "محمد علي",
    rating: 4,
    count: "منذ 5 ساعات",
    review:
      "خدمة ممتازة من حوف المنازل، قمت بطلب خدمة تنظيف السجاد والكنب وكانت النتيجة أكثر من رائعة. السجاد عاد وكأنه جديد تماماً بعد أن كان يعاني من بقع صعبة. الكنب أيضاً أصبح نظيفاً ومعطراً. سعر الخدمة معقول والفريق محترف في عمله. أقترح فقط تقليل وقت الانتظار للحجز، لكن بشكل عام تجربة ممتازة.",
    image: Opinions3,
  },
  {
    id: 4,
    name: "سارة يوسف",
    rating: 5,
    count: "منذ 3 أسابيع",
    review:
      "تعاملت مع حوف المنازل للمرة الثالثة وفي كل مرة تزداد ثقتي بخدماتهم. المواعيد دقيقة جداً والعمال مدربون على أعلى مستوى. المواد المستخدمة في التنظيف آمنة وصديقة للبيئة وهذا ما أبحث عنه دائماً خاصة مع وجود أطفال في المنزل. الشفافية في التعامل والحرص على رضا العميل من أهم ما يميز هذه الشركة.",
    image: Opinions1,
  },
  {
    id: 5,
    name: "أحمد محمود",
    rating: 5,
    count: "منذ شهر",
    review:
      "أنا من العملاء الدائمين لحوف المنازل وأطلب خدماتهم بشكل شهري. ما يميزهم هو الاستمرارية في تقديم خدمة عالية الجودة في كل مرة. الفريق متعاون جداً ويستمع لملاحظاتي بكل اهتمام. تطبيق الحجز سهل الاستخدام والدفع الإلكتروني ميزة رائعة. بصراحة، لم أعد أضيع وقتي في البحث عن خدمات تنظيف أخرى بعد تجربتي معهم.",
    image: Opinions2,
  },
];

// Enhanced company description with more details
export const companyInfo = {
  mainDescription: "أطلب بثقة وأمان جميع مقدمى الخدمات متعاقدين ومضمونين",
  aboutUs:
    "نحن شركة رائدة في مجال الخدمات المنزلية والصيانة منذ أكثر من 15 عامًا، نفتخر بتقديم أفضل الخدمات بأعلى معايير الجودة والأمان",
  mission:
    "مهمتنا هي توفير حلول صيانة متكاملة تلبي احتياجات عملائنا بكفاءة عالية وأسعار منافسة",
  values:
    "نلتزم بالمصداقية والشفافية والاحترافية في جميع تعاملاتنا، ونضمن رضا العملاء في كل خدمة نقدمها داخل مجتمعنا السعودي المحافظ",
  experience:
    "يتكون فريقنا من خبراء متخصصين في مجالات السباكة والكهرباء والنجارة والتكييف، حيث يمتلك كل فني خبرة لا تقل عن 10 سنوات في مجاله",
  guarantee:
    "نقدم ضمان شامل على جميع خدماتنا لمدة عام كامل، مع خدمة دعم فني متاحة على مدار الساعة للرد على استفساراتكم وطلباتكم",
};





export const photosApi = "https://api.houfalmanazel.com/";



// ============ CONSTANTS ============
export const weekDays = [
  "سبت",
  "أحد",
  "اثنين",
  "ثلاثاء",
  "أربعاء",
  "خميس",
  "جمعة",
];
export const monthNames = [
  "يناير",
  "فبراير",
  "مارس",
  "إبريل",
  "مايو",
  "يونيو",
  "يوليو",
  "أغسطس",
  "سبتمبر",
  "أكتوبر",
  "نوفمبر",
  "ديسمبر",
];


// Saudi regions & selected governorates
// Coordinates are city-centers (not polygon centroids), 6-decimal precision.
export const SaudiArabiaAreas = [
  {
    areaId: "SA-01",
    areaNameArabic: "الرياض",
    areaNameEnglish: "Riyadh",
    coordinates: [24.650000, 46.700000],
    governorates: [
      { id: "SA-01-01", nameArabic: "الدرعية", nameEnglish: "Ad Diriyah", coordinates: [24.744028, 46.576934] },
      { id: "SA-01-02", nameArabic: "الخرج", nameEnglish: "Al Kharj", coordinates: [24.155590, 47.334660] },
      { id: "SA-01-03", nameArabic: "الدوادمي", nameEnglish: "Ad Dawadmi", coordinates: [24.507325, 44.392323] },
      { id: "SA-01-04", nameArabic: "رماح", nameEnglish: "Rumah", coordinates: [25.911700, 46.288700] },
      { id: "SA-01-05", nameArabic: "شقراء", nameEnglish: "Shaqra", coordinates: [25.258200, 45.262000] },
      { id: "SA-01-06", nameArabic: "الزلفي", nameEnglish: "Al Zulfi", coordinates: [26.299400, 44.815000] },
      { id: "SA-01-07", nameArabic: "المزاحمية", nameEnglish: "Al Muzahimiyah", coordinates: [24.470900, 46.262200] },
      { id: "SA-01-08", nameArabic: "عفيف", nameEnglish: "Afif", coordinates: [23.906000, 42.917000] },
      { id: "SA-01-09", nameArabic: "حريملاء", nameEnglish: "Huraymila", coordinates: [25.110900, 46.102200] },
      { id: "SA-01-10", nameArabic: "المجمعة", nameEnglish: "Al Majma'ah", coordinates: [25.905600, 45.361900] },
      { id: "SA-01-11", nameArabic: "القويعية", nameEnglish: "Al Quway'iyah", coordinates: [24.068900, 45.287500] },
      { id: "SA-01-12", nameArabic: "وادي الدواسر", nameEnglish: "Wadi Al Dawasir", coordinates: [20.502800, 44.854400] },
      { id: "SA-01-13", nameArabic: "الأفلاج", nameEnglish: "Al Aflaj", coordinates: [22.103900, 46.693900] },
      { id: "SA-01-14", nameArabic: "حوطة بني تميم", nameEnglish: "Hawtat Bani Tamim", coordinates: [23.516700, 46.850000] },
      { id: "SA-01-15", nameArabic: "السليل", nameEnglish: "As Sulayyil", coordinates: [20.462500, 45.577800] },
      { id: "SA-01-16", nameArabic: "ضرماء", nameEnglish: "Dhurma", coordinates: [24.645000, 46.280000] },
      { id: "SA-01-17", nameArabic: "ثادق", nameEnglish: "Thadiq", coordinates: [25.292800, 45.873100] },
      { id: "SA-01-18", nameArabic: "الحريق", nameEnglish: "Al Hariq", coordinates: [23.918600, 46.907800] },
      { id: "SA-01-19", nameArabic: "الغاط", nameEnglish: "Al Ghat", coordinates: [26.031700, 45.030000] },
      { id: "SA-01-20", nameArabic: "مرات", nameEnglish: "Marat", coordinates: [25.044200, 42.246900] }
    ]
  },
  {
    areaId: "SA-02",
    areaNameArabic: "مكة المكرمة",
    areaNameEnglish: "Makkah",
    coordinates: [21.422510, 39.826168],
    governorates: [
      { id: "SA-02-01", nameArabic: "مكة المكرمة", nameEnglish: "Makkah", coordinates: [21.422510, 39.826168] },
      { id: "SA-02-02", nameArabic: "جدة", nameEnglish: "Jeddah", coordinates: [21.485811, 39.192505] },
      { id: "SA-02-03", nameArabic: "الطائف", nameEnglish: "Taif", coordinates: [21.285406, 40.536904] },
      { id: "SA-02-04", nameArabic: "رابغ", nameEnglish: "Rabigh", coordinates: [22.798300, 39.034900] },
      { id: "SA-02-05", nameArabic: "الكامل", nameEnglish: "Al Kamil", coordinates: [22.114900, 39.951900] },
      { id: "SA-02-06", nameArabic: "القنفذة", nameEnglish: "Al Qunfudhah", coordinates: [19.126400, 41.078900] },
      { id: "SA-02-07", nameArabic: "الخرمة", nameEnglish: "Al Khurma", coordinates: [21.917200, 42.028900] },
      { id: "SA-02-08", nameArabic: "الليث", nameEnglish: "Al Lith", coordinates: [20.157800, 40.267800] },
      { id: "SA-02-09", nameArabic: "خليص", nameEnglish: "Khulais", coordinates: [22.354200, 39.211900] },
      { id: "SA-02-10", nameArabic: "رنية", nameEnglish: "Ranyah", coordinates: [21.272800, 42.825000] },
      { id: "SA-02-11", nameArabic: "تربة", nameEnglish: "Turbah", coordinates: [21.216100, 41.629700] },
      { id: "SA-02-12", nameArabic: "الجموم", nameEnglish: "Al Jumum", coordinates: [21.608900, 39.700000] },
      { id: "SA-02-13", nameArabic: "أضم", nameEnglish: "Adham", coordinates: [19.929700, 41.686900] },
      { id: "SA-02-14", nameArabic: "المويه", nameEnglish: "Al Muwayh", coordinates: [22.435800, 41.758300] },
      { id: "SA-02-15", nameArabic: "ميسان", nameEnglish: "Maysan", coordinates: [20.338300, 41.813900] },
      { id: "SA-02-16", nameArabic: "أرينبة", nameEnglish: "Arinbah", coordinates: [21.706700, 40.000000] },
      { id: "SA-02-17", nameArabic: "العرضيات", nameEnglish: "Al Ardiyat", coordinates: [19.978600, 41.654200] }
    ]
  },
  {
    areaId: "SA-03",
    areaNameArabic: "المدينة المنورة",
    areaNameEnglish: "Madinah",
    coordinates: [24.470901, 39.612236],
    governorates: [
      { id: "SA-03-01", nameArabic: "المدينة المنورة", nameEnglish: "Madinah", coordinates: [24.470901, 39.612236] },
      { id: "SA-03-02", nameArabic: "ينبع", nameEnglish: "Yanbu", coordinates: [24.090800, 38.061800] },
      { id: "SA-03-03", nameArabic: "العلا", nameEnglish: "AlUla", coordinates: [26.616700, 37.916700] },
      { id: "SA-03-04", nameArabic: "بدر", nameEnglish: "Badr", coordinates: [23.782800, 38.790500] },
      { id: "SA-03-05", nameArabic: "الحناكية", nameEnglish: "Al Hinakiyah", coordinates: [24.886000, 40.541000] },
      { id: "SA-03-06", nameArabic: "ينبع البحر", nameEnglish: "Yanbu Al Bahr", coordinates: [24.084000, 38.056000] },
      { id: "SA-03-07", nameArabic: "مهد الذهب", nameEnglish: "Mahd Al Dhahab", coordinates: [23.510800, 40.866700] },
      { id: "SA-03-08", nameArabic: "خيبر", nameEnglish: "Khaybar", coordinates: [25.701400, 39.292200] },
      { id: "SA-03-09", nameArabic: "وادي الفرع", nameEnglish: "Wadi Al Fara'", coordinates: [24.694400, 38.408300] }
    ]
  },
  {
    areaId: "SA-04",
    areaNameArabic: "القصيم",
    areaNameEnglish: "Al Qassim",
    coordinates: [26.326000, 43.975000],
    governorates: [
      { id: "SA-04-01", nameArabic: "بريدة", nameEnglish: "Buraidah", coordinates: [26.359200, 43.981800] },
      { id: "SA-04-02", nameArabic: "عنيزة", nameEnglish: "Unaizah", coordinates: [26.084400, 43.992800] },
      { id: "SA-04-03", nameArabic: "النبهانية", nameEnglish: "Al Nabhaniyah", coordinates: [25.731700, 43.416900] },
      { id: "SA-04-04", nameArabic: "الرس", nameEnglish: "Ar Rass", coordinates: [25.869400, 43.497300] },
      { id: "SA-04-05", nameArabic: "المذنب", nameEnglish: "Al Midhnab", coordinates: [25.866100, 44.214200] },
      { id: "SA-04-06", nameArabic: "البكيرية", nameEnglish: "Al Bukayriyah", coordinates: [26.136900, 43.655800] },
      { id: "SA-04-07", nameArabic: "البدائع", nameEnglish: "Al Badai'", coordinates: [25.935800, 43.714200] },
      { id: "SA-04-08", nameArabic: "عيون الجواء", nameEnglish: "Uyun Al Jiwa", coordinates: [26.396700, 44.325000] },
      { id: "SA-04-09", nameArabic: "الأسياح", nameEnglish: "Al Asyah", coordinates: [26.325800, 44.204200] },
      { id: "SA-04-10", nameArabic: "رياض الخبراء", nameEnglish: "Riyadh Al Khabra", coordinates: [25.939400, 44.138300] },
      { id: "SA-04-11", nameArabic: "الشماسية", nameEnglish: "Ash Shimasiyah", coordinates: [25.649200, 43.205600] },
      { id: "SA-04-12", nameArabic: "عقلة الصقور", nameEnglish: "Uqlat Assuqur", coordinates: [25.855800, 43.234700] },
      { id: "SA-04-13", nameArabic: "ضرية", nameEnglish: "Dhariyah", coordinates: [25.002200, 43.675000] }
    ]
  },
  {
    areaId: "SA-05",
    areaNameArabic: "المنطقة الشرقية",
    areaNameEnglish: "Eastern Province",
    coordinates: [26.425699, 50.055164],
    governorates: [
      { id: "SA-05-01", nameArabic: "الدمام", nameEnglish: "Dammam", coordinates: [26.425699, 50.055164] },
      { id: "SA-05-02", nameArabic: "الهفوف", nameEnglish: "Al Hofuf", coordinates: [25.383333, 49.583333] },
      { id: "SA-05-03", nameArabic: "الخبر", nameEnglish: "Al Khobar", coordinates: [26.217200, 50.197100] },
      { id: "SA-05-04", nameArabic: "الأحساء", nameEnglish: "Al Ahsa", coordinates: [25.395700, 49.577500] },
      { id: "SA-05-05", nameArabic: "الجبيل", nameEnglish: "Al Jubail", coordinates: [27.004600, 49.660100] },
      { id: "SA-05-06", nameArabic: "رأس تنورة", nameEnglish: "Ras Tanura", coordinates: [26.707417, 50.067352] },
      { id: "SA-05-07", nameArabic: "النعيرية", nameEnglish: "An Nairyah", coordinates: [27.474960, 48.483724] },
      { id: "SA-05-08", nameArabic: "القطيف", nameEnglish: "Qatif", coordinates: [26.565191, 49.996376] },
      { id: "SA-05-09", nameArabic: "حفر الباطن", nameEnglish: "Hafar Al Batin", coordinates: [28.432800, 45.970300] },
      { id: "SA-05-10", nameArabic: "الخفجي", nameEnglish: "Al Khafji", coordinates: [28.439200, 48.491400] },
      { id: "SA-05-11", nameArabic: "بقيق", nameEnglish: "Buqayq", coordinates: [25.925600, 49.689700] },
      { id: "SA-05-12", nameArabic: "أبو حدرية", nameEnglish: "Abu Hadriyah", coordinates: [27.275800, 49.306900] },
      { id: "SA-05-13", nameArabic: "العديد", nameEnglish: "Al Udaid", coordinates: [25.304700, 49.129400] }
    ]
  },
  {
    areaId: "SA-06",
    areaNameArabic: "حائل",
    areaNameEnglish: "Hail",
    coordinates: [27.523647, 41.696632],
    governorates: [
      { id: "SA-06-01", nameArabic: "حائل", nameEnglish: "Hail", coordinates: [27.523647, 41.696632] },
      { id: "SA-06-02", nameArabic: "بقعاء", nameEnglish: "Baqa'a", coordinates: [28.210900, 42.566100] },
      { id: "SA-06-03", nameArabic: "الغزالة", nameEnglish: "Al Ghazalah", coordinates: [26.962200, 41.986100] },
      { id: "SA-06-04", nameArabic: "الشنان", nameEnglish: "Ash Shinan", coordinates: [27.006900, 41.052500] },
      { id: "SA-06-05", nameArabic: "السليمي", nameEnglish: "As Sulaymi", coordinates: [27.865600, 40.848600] },
      { id: "SA-06-06", nameArabic: "الحائط", nameEnglish: "Al Ha'it", coordinates: [27.728600, 41.294200] },
      { id: "SA-06-07", nameArabic: "الشملي", nameEnglish: "Ash Shamli", coordinates: [27.306100, 41.743100] },
      { id: "SA-06-08", nameArabic: "موقق", nameEnglish: "Mawqaq", coordinates: [28.028600, 41.354700] },
      { id: "SA-06-09", nameArabic: "سميراء", nameEnglish: "Sumayra", coordinates: [26.585800, 41.213900] }
    ]
  },
  {
    areaId: "SA-07",
    areaNameArabic: "تبوك",
    areaNameEnglish: "Tabuk",
    coordinates: [28.397220, 36.578890],
    governorates: [
      { id: "SA-07-01", nameArabic: "تبوك", nameEnglish: "Tabuk", coordinates: [28.397220, 36.578890] },
      { id: "SA-07-02", nameArabic: "ضباء", nameEnglish: "Duba", coordinates: [27.350600, 35.690200] },
      { id: "SA-07-03", nameArabic: "حقل", nameEnglish: "Haql", coordinates: [29.280600, 34.935200] },
      { id: "SA-07-04", nameArabic: "الوجه", nameEnglish: "Al Wajh", coordinates: [26.245800, 36.455600] },
      { id: "SA-07-05", nameArabic: "تيماء", nameEnglish: "Tayma", coordinates: [27.634200, 38.498300] },
      { id: "SA-07-06", nameArabic: "أملج", nameEnglish: "Umluj", coordinates: [25.023100, 37.268300] },
      { id: "SA-07-07", nameArabic: "البدع", nameEnglish: "Al Bada'", coordinates: [27.805600, 35.002800] }
    ]
  },
  {
    areaId: "SA-08",
    areaNameArabic: "الحدود الشمالية",
    areaNameEnglish: "Northern Borders",
    coordinates: [30.983334, 41.016666],
    governorates: [
      { id: "SA-08-01", nameArabic: "رفحاء", nameEnglish: "Rafha", coordinates: [29.634200, 43.514300] },
      { id: "SA-08-02", nameArabic: "عرعر", nameEnglish: "Arar", coordinates: [30.983334, 41.016666] },
      { id: "SA-08-03", nameArabic: "طريف", nameEnglish: "Turaif", coordinates: [31.672500, 38.663600] },
      { id: "SA-08-04", nameArabic: "العويقيلة", nameEnglish: "Al Uwayqilah", coordinates: [30.481700, 42.276900] }
    ]
  },
  {
    areaId: "SA-09",
    areaNameArabic: "جازان",
    areaNameEnglish: "Jazan",
    coordinates: [16.889300, 42.551100],
    governorates: [
      { id: "SA-09-01", nameArabic: "جازان", nameEnglish: "Jazan", coordinates: [16.889300, 42.551100] },
      { id: "SA-09-02", nameArabic: "صبيا", nameEnglish: "Sabya", coordinates: [17.144900, 42.625600] },
      { id: "SA-09-03", nameArabic: "الدرب", nameEnglish: "Ad Darb", coordinates: [17.722500, 42.252200] },
      { id: "SA-09-04", nameArabic: "أبو عريش", nameEnglish: "Abu Arish", coordinates: [16.969700, 42.831100] },
      { id: "SA-09-05", nameArabic: "صامطة", nameEnglish: "Samtah", coordinates: [16.596900, 42.944200] },
      { id: "SA-09-06", nameArabic: "بيش", nameEnglish: "Baysh", coordinates: [17.319200, 42.597800] },
      { id: "SA-09-07", nameArabic: "فرسان", nameEnglish: "Farasan", coordinates: [16.702800, 41.992500] },
      { id: "SA-09-08", nameArabic: "العارضة", nameEnglish: "Al Aridah", coordinates: [17.313900, 43.092800] },
      { id: "SA-09-09", nameArabic: "أحد المسارحة", nameEnglish: "Ahad Al Masarihah", coordinates: [16.742800, 43.012500] },
      { id: "SA-09-10", nameArabic: "الحرث", nameEnglish: "Al Harith", coordinates: [17.039400, 43.378900] },
      { id: "SA-09-11", nameArabic: "الريث", nameEnglish: "Ar Rayth", coordinates: [17.204200, 43.213900] },
      { id: "SA-09-12", nameArabic: "ضمد", nameEnglish: "Damad", coordinates: [16.715600, 42.926700] },
      { id: "SA-09-13", nameArabic: "فيفا", nameEnglish: "Fayfa", coordinates: [17.238900, 43.116700] },
      { id: "SA-09-14", nameArabic: "الداير", nameEnglish: "Ad Dayer", coordinates: [17.454700, 43.110000] },
      { id: "SA-09-15", nameArabic: "العيدابي", nameEnglish: "Al Aidabi", coordinates: [16.951400, 42.685800] },
      { id: "SA-09-16", nameArabic: "هروب", nameEnglish: "Harub", coordinates: [17.531400, 42.350600] },
      { id: "SA-09-17", nameArabic: "الطوال", nameEnglish: "At Tuwal", coordinates: [17.466700, 42.833300] }
    ]
  },
  {
    areaId: "SA-10",
    areaNameArabic: "نجران",
    areaNameEnglish: "Najran",
    coordinates: [17.565600, 44.228900],
    governorates: [
      { id: "SA-10-01", nameArabic: "نجران", nameEnglish: "Najran", coordinates: [17.565600, 44.228900] },
      { id: "SA-10-02", nameArabic: "حبونا", nameEnglish: "Habuna", coordinates: [17.615000, 44.531400] },
      { id: "SA-10-03", nameArabic: "ثار", nameEnglish: "Thar", coordinates: [17.482600, 43.507000] },
      { id: "SA-10-04", nameArabic: "شرورة", nameEnglish: "Sharurah", coordinates: [17.466700, 47.106700] },
      { id: "SA-10-05", nameArabic: "بدر الجنوب", nameEnglish: "Badr Al Janoub", coordinates: [18.015300, 44.116700] },
      { id: "SA-10-06", nameArabic: "يدمة", nameEnglish: "Yadamah", coordinates: [17.280000, 44.704400] },
      { id: "SA-10-07", nameArabic: "خباش", nameEnglish: "Khabbash", coordinates: [17.833300, 44.500000] }
    ]
  },
  {
    areaId: "SA-11",
    areaNameArabic: "الباحة",
    areaNameEnglish: "Al Baha",
    coordinates: [20.013600, 41.468600],
    governorates: [
      { id: "SA-11-01", nameArabic: "الباحة", nameEnglish: "Al Baha", coordinates: [20.013600, 41.468600] },
      { id: "SA-11-02", nameArabic: "بلجرشي", nameEnglish: "Baljurashi", coordinates: [19.851600, 41.560800] },
      { id: "SA-11-03", nameArabic: "المندق", nameEnglish: "Al Mandaq", coordinates: [20.190600, 41.280900] },
      { id: "SA-11-04", nameArabic: "المخواة", nameEnglish: "Al Mikhwah", coordinates: [19.806700, 41.368300] },
      { id: "SA-11-05", nameArabic: "قلوة", nameEnglish: "Qilwah", coordinates: [19.639200, 41.644200] },
      { id: "SA-11-06", nameArabic: "العقيق", nameEnglish: "Al Aqiq", coordinates: [20.294200, 41.678900] },
      { id: "SA-11-07", nameArabic: "الحجرة", nameEnglish: "Al Hajrah", coordinates: [19.986900, 41.227800] },
      { id: "SA-11-08", nameArabic: "القرى", nameEnglish: "Al Qura", coordinates: [19.701400, 41.443100] },
      { id: "SA-11-09", nameArabic: "غامد الزناد", nameEnglish: "Ghamid Al Zinad", coordinates: [19.933300, 41.366700] },
      { id: "SA-11-10", nameArabic: "بني حسن", nameEnglish: "Bani Hasan", coordinates: [19.700000, 41.500000] }
    ]
  },
  {
    areaId: "SA-12",
    areaNameArabic: "الجوف",
    areaNameEnglish: "Al Jawf",
    coordinates: [29.971100, 40.206400],
    governorates: [
      { id: "SA-12-01", nameArabic: "سكاكا", nameEnglish: "Sakaka", coordinates: [29.971100, 40.206400] },
      { id: "SA-12-02", nameArabic: "دومة الجندل", nameEnglish: "Dumat Al Jandal", coordinates: [29.815300, 39.865500] },
      { id: "SA-12-03", nameArabic: "طبرجل", nameEnglish: "Tabarjal", coordinates: [30.499900, 38.216000] },
      { id: "SA-12-04", nameArabic: "القريات", nameEnglish: "Al Qurayyat", coordinates: [31.332500, 37.341900] }
    ]
  },
  {
    areaId: "SA-13",
    areaNameArabic: "عسير",
    areaNameEnglish: "Asir",
    coordinates: [18.246500, 42.511700],
    governorates: [
      { id: "SA-13-01", nameArabic: "أبها", nameEnglish: "Abha", coordinates: [18.246500, 42.511700] },
      { id: "SA-13-02", nameArabic: "بيشة", nameEnglish: "Bisha", coordinates: [19.984000, 42.589100] },
      { id: "SA-13-03", nameArabic: "تنومة", nameEnglish: "Tanomah", coordinates: [18.912800, 42.140100] },
      { id: "SA-13-04", nameArabic: "خميس مشيط", nameEnglish: "Khamis Mushait", coordinates: [18.306700, 42.728900] },
      { id: "SA-13-05", nameArabic: "النماص", nameEnglish: "Al Namas", coordinates: [19.143900, 42.119400] },
      { id: "SA-13-06", nameArabic: "محايل", nameEnglish: "Muhayil", coordinates: [18.513300, 42.046700] },
      { id: "SA-13-07", nameArabic: "سراة عبيدة", nameEnglish: "Sarat Abidah", coordinates: [18.250800, 42.676900] },
      { id: "SA-13-08", nameArabic: "أحد رفيدة", nameEnglish: "Ahad Rifaydah", coordinates: [18.177800, 42.791700] },
      { id: "SA-13-09", nameArabic: "رجال ألمع", nameEnglish: "Rijal Alma", coordinates: [18.205800, 42.242500] },
      { id: "SA-13-10", nameArabic: "تثليث", nameEnglish: "Tathlith", coordinates: [19.653900, 43.853900] },
      { id: "SA-13-11", nameArabic: "ظهران الجنوب", nameEnglish: "Dhahran Al Janoub", coordinates: [17.709700, 44.215800] },
      { id: "SA-13-12", nameArabic: "المجاردة", nameEnglish: "Al Majardah", coordinates: [18.601900, 41.894200] },
      { id: "SA-13-13", nameArabic: "البرك", nameEnglish: "Al Birk", coordinates: [18.928600, 41.639400] },
      { id: "SA-13-14", nameArabic: "بللسمر", nameEnglish: "Balasmar", coordinates: [18.081700, 42.631100] },
      { id: "SA-13-15", nameArabic: "بلقرن", nameEnglish: "Balgarn", coordinates: [19.645800, 41.705600] }
    ]
  }
];

